<template>
    <BreadCrumb PageTitle="Liste des Directions" />
    <ListeTypeOrganisation />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTypeOrganisation from "@/components/TypeOrganisation/ListeTypeOrganisation.vue";

    export default defineComponent({
        name: "ListeTypeOrganisationPage",
        components: {
            BreadCrumb,
            ListeTypeOrganisation,
        },
    });
</script>